import React from "react";
import ReactECharts from 'echarts-for-react';
import { handleLanguageChange } from "../../utils/multiLangDashboardV2Data";
import { Grid, Typography, Box, Tooltip, ClickAwayListener } from '@mui/material';
import { CustomTooltip, FormatToShortNumber, formatNumberTimeField, isMobileView } from "../../utils/Reusables";
//import { StringTruncate } from '../../utils/Reusables';

export default function NumberGraphicCard(props) {
    const { resultSet, fieldFormat, COLORS_SERIES, reportName, description, backgroundColor, settings } = props;
    let values = []
    let fixedLabel
    let isPercent = false // Even if single field is of % type, then we will add % symbol to output string
    //console.log('Number chart')
    const [tooltipOpen, setTooltipOpen] = React.useState(false);

    const handleTooltipClose = () => {
        setTooltipOpen(false);
    };

    const handleTooltipOpen = () => {
        if(tooltipOpen) {
            setTooltipOpen(false);
        } else {
            setTooltipOpen(true);
        }
        
    };

    resultSet.series().map(s => {
        values = [s?.series?.[0]?.value] ?? 0 //Only first value will be rendered
        fixedLabel = s?.series?.[0]?.x //Only first value will be rendered
        if (s?.key && fieldFormat?.[s?.key] === 'percent') {
            isPercent = true
        }
    })

    let totalNum = values.reduce((a, b) => a + b, 0)
    if (settings?.conditionalFormat && settings?.conditionalFormat?.length && settings?.conditionalFormat[0]?.decimalPrecision) {
        totalNum = Number(totalNum).toFixed(settings?.conditionalFormat[0]?.decimalPrecision)
    }
    else {
        totalNum = Math.round(Number(totalNum))
    }

    let formattedTotalNum;
    if (settings?.dataFormat?.timeFormat) {
        formattedTotalNum = formatNumberTimeField(totalNum, settings?.dataFormat?.timeFormat, true);
        if(formattedTotalNum.indexOf("Hr") != -1 ) {
            let formattedTotalNumArr = formattedTotalNum.split("Hr");
            formattedTotalNum = formattedTotalNumArr[0] + "Hr" + "\n" + formattedTotalNumArr[1]
        }
    } else {
        if(!(settings?.dataFormat?.currencyFormat || settings?.dataFormat?.format === 'percentage')) {
            formattedTotalNum = FormatToShortNumber(totalNum);
        } else {
            formattedTotalNum = null;
        }
    }

    const backgroundColorCode = settings?.numberChartTemplate?.config?.color || settings?.colorCode || backgroundColor;

    const circularProgressOption = (data, formattedData) => ({
        series: [
            {
                type: "gauge",
                smooth: true,
                radius: "100%",
                startAngle: 90,
                endAngle: -270,
                center: ["50%", "50%"],
                min: 0,
                max: 100,
                itemStyle: {
                    color: "#fff"
                },
                progress: {
                    show: true,
                    roundCap: true,
                    width: 5
                },
                pointer: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        width: 5,
                        color: [[1, '#fff']],
                        opacity: 0.5
                    }
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    show: false
                },
                title: {
                    show: false,
                    width: 90,
                    offsetCenter: ["75", "-10"],
                    overflow: "break"
                },
                detail: {
                    offsetCenter: [0, 0],
                    lineHeight: (formattedData ? 23 : (isMobileView() ? 23 : 28)),
                    valueAnimation: true,
                    color: "#fff",
                    fontSize: (formattedData ? "18px" : (isMobileView() ? "18px" : "22px")),
                    fontFamily: `"Open Sans", sans-serif`,
                    formatter: function (v) {
                        if (isPercent)
                            return v + "%"
                        else {
                            if(formattedData) return `${formattedData}`
                            return v
                        }
                            
                    },
                    rich: {
                        score: {
                            color: "#fff",
                            fontSize: 8
                        },
                        status: {
                            color: "#fff",
                            fontSize: 8
                        }
                    }
                },
                data
            }
        ]
    });

    return <div className={"graphic-number-card number-card"} style={{ backgroundColor: backgroundColorCode, height: '100%', width: 'initial' }}>
        <Grid className="er-stats-card-grid">
            <Box className="er-stats-card-grid-chart" >
                <ReactECharts option={circularProgressOption([totalNum], formattedTotalNum)} style={{ height: (isMobileView() ? "70px" : "100px"), width: (isMobileView() ? "70px" : "100px") }} opts={{ renderer: 'svg' }} />
            </Box>
            <Box className="er-stats-card-grid-content"  >
                <Box>
                    <Typography variant="body2" className="er-stats-card-title">{handleLanguageChange(reportName ? reportName : 'New Report')}</Typography>
                    {/* <ClickAwayListener onClickAway={handleTooltipClose}> */}
                        <CustomTooltip
                            placement="bottom"
                            // disableTriggerFocus={true} 
                            PopperProps={{
                                disablePortal: true,
                            }}
                            classes={{ tooltip: 're-tooltip' }} 
                            onClose={handleTooltipClose}
                            open={tooltipOpen}
                            // disableFocusListener
                            // disableHoverListener
                            // disableTouchListener
                            title={handleLanguageChange(fixedLabel ? fixedLabel : description ? description : 'No Data')}
                        >
                            <Typography variant="body2" className="er-stats-card-subtitle er-stats-card-subtitle-bold" onClick={handleTooltipOpen} >
                                {handleLanguageChange(fixedLabel ? fixedLabel : description ? description : 'No Data')}
                            </Typography>
                        </CustomTooltip>
                    {/* </ClickAwayListener> */}
                </Box>
            </Box>
        </Grid>
    </div>
}
